import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import UploadModal from "./UploadModal";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import UploadRoundedIcon from "@mui/icons-material/UploadRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import Pager from "../../../Shared/Pagination/Pagination";
import DetailGANSAL from "./detail";
import {
  Grid,
  Tooltip,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import s from "./CuponesGanadoresTelekino.module.css";
import masiveDistributionServices from "../../../../api/delivery/masiveDistribution";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import Swal from "sweetalert2";
import { dateFormats } from "../../../../helpers/convertDate";
import useTranslationException from "../../../../helpers/exceptions";

const CuponesGanadoresTelekino = () => {
  const dates = dateFormats();
  const [open, setOpen] = useState(false);
  const [prizes, setPrizes] = useState([]);
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const [sort, setSort] = useState({
    criteria: "DESC",
    field: "",
  });

  const { textColor } = useSelector((state) => state.local);

  const [detail, setDetail] = useState({
    status: false,
    data: {},
  });
  const [loadingDelete, setLoadingDelete] = useState({
    id: 0,
    status: false,
  });

  //pager
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);

  const getFiles = () => {
    setLoading(true);
    masiveDistributionServices
      .getPrizesGanza(page, pageSize, sort)
      .then((res) => {
        console.log(res);
        setPrizes(res.content);
        setTotalPages(res.totalPages);
      })
      .then(() => setLoading(false))
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
      });
  };

  useEffect(() => {
    getFiles();
  }, [page, pageSize, sort]);

  const handleDetail = (item) => {
    setDetail({
      status: true,
      data: item,
    });
  };

  const handleDelete = (item) => {
    setLoadingDelete({
      id: item.id,
      status: true,
    });
    Swal.fire({
      title: `${t("deleteFile")}: ${item.fileName.split("tmp")[1] || item.fileName.split("tmp")}`,
      text: `${t("deleteTarascaText")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00A36C",
      cancelButtonColor: "#d33",
      confirmButtonText: t("confirm"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        masiveDistributionServices
          .deleteGansalFile(item?.id)
          .then(() => {
            Swal.fire(
              t("successDeleteTarascaTitle"),
              t("successDeleteTarascaText"),
              "success",
            ).then(() => {
              getFiles();
              setLoadingDelete({
                id: 0,
                status: false,
              });
            });
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("sorryErrorOcurred"),
              t("retry"),
            );
            setLoadingDelete({
              id: 0,
              status: false,
            });
          });
      } else {
        setLoadingDelete({
          id: 0,
          status: false,
        });
      }
    });
  };

  const handleSort = (name) => {
    setSort((prev) => ({
      criteria:
        prev.field === name
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: name,
    }));
  };

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: ".9rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    cursor: "pointer",
  };

  return (
    <Grid container className={s.container}>
      {detail.status ? (
        <DetailGANSAL detail={detail} setDetail={setDetail} />
      ) : (
        <>
          <Grid item container xs={11} className={s.header}>
            <Grid item xs={12} lg={5} md={8} className={s.titleContainer}>
              <EmojiEventsIcon
                sx={{ fontSize: "2rem", color: "primary.main" }}
              />
              <h4>{t("winnersCouponsTelekino")}</h4>
            </Grid>
            <Grid item xs={12} lg={2} md={3}>
              <Tooltip placement="top" title={t("uploadFile")}>
                <Button
                  disabled={loadingDelete.status}
                  variant="contained"
                  className={s.uploadBtn}
                  onClick={() => setOpen(true)}
                >
                  <UploadRoundedIcon sx={{ fontSize: "2rem" }} />
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
          {loading ? (
            <Grid item xs={11} className={s.loader}>
              <CircularProgress size={"3rem"} />
            </Grid>
          ) : prizes?.length ? (
            <Grid item container xs={11} className={s.data}>
              <TableContainer className={s.tableContainer}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("fileName")}
                      >
                        {`${t("archive")} ${sort.field === "fileName" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("raffleNumber")}
                      >
                        {`${t("drawNumber")} ${sort.field === "raffleNumber" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("processDate")}
                      >
                        {`${t("processDate")} ${sort.field === "processDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        {t("delete")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {prizes?.map((item, i) => (
                      <React.Fragment key={item.id}>
                        <TableRow
                          sx={{
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                            onClick={() => handleDetail(item)}
                          >
                            {item.fileName.split("tmp") || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                            onClick={() => handleDetail(item)}
                          >
                            {item.emission || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                            onClick={() => handleDetail(item)}
                          >
                            {dates.formatDate(item.processDate)}
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {loadingDelete.status ? (
                              loadingDelete.id === item.id ? (
                                <CircularProgress size={"2rem"} />
                              ) : (
                                <DeleteForeverRoundedIcon
                                  sx={{ color: "grey", fontSize: "2rem" }}
                                />
                              )
                            ) : (
                              <DeleteForeverRoundedIcon
                                className={s.iconbtn}
                                sx={{ color: "primary.dark" }}
                                onClick={() => handleDelete(item)}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: "50px",
                }}
              >
                <Pager
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageCustom={pageCustom}
                  setPageCustom={setPageCustom}
                />
              </Grid>
            </Grid>
          ) : (
            <Grid item xs={12} className={s.noResults}>
              {t("noResults")}
            </Grid>
          )}

          {open ? (
            <UploadModal open={open} setOpen={setOpen} getFiles={getFiles} />
          ) : null}
        </>
      )}
    </Grid>
  );
};

export default CuponesGanadoresTelekino;
